import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: 0,
};
//gelen class acitve class ıd tutyor class 2=1,class 3=2 class 4=3; burda 1,2, veya 3 değeri tutar;
export const activeComponentSlice = createSlice({
  name: "activeComponent",
  initialState,
  reducers: {
    activeComponentValue: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { activeComponentValue } = activeComponentSlice.actions;
export default activeComponentSlice.reducer;
